import classnames from "classnames";
import { difference, noop } from "lodash";
import { Link } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { toQueryString } from "@/react/helpers/urlHelpers";
import { useRouterQueryParams } from "@/react/hooks/useRouterQueryParams";
import type { PostSort } from "@/react/types/CurrentCommunity";

export const SORT_TYPES: PostSort[] = [
  "alphabetical",
  "latest",
  "likes",
  "new_activity",
  "oldest",
  "popular",
];

export interface SortByListProps {
  defaultSort: PostSort;
  descriptorClass?: string;
  exclude?: PostSort[];
  onClick?: (sortType: PostSort) => void;
  showDescription?: boolean;
}

export const SortByList = ({
  defaultSort,
  exclude = [],
  onClick = noop,
  showDescription = true,
  descriptorClass = "dropdown-menu__descriptor",
}: SortByListProps) => {
  const availableSortTypes: PostSort[] = difference(SORT_TYPES, exclude);
  const fallbackSort = defaultSort || availableSortTypes[0];
  const { sort = fallbackSort, ...rest } = useRouterQueryParams();

  return (
    <ul>
      {availableSortTypes.map(sortType => (
        <li key={sortType}>
          <Link
            to={`?${toQueryString({ ...rest, sort: sortType })}`}
            onClick={() => onClick(sortType)}
            className={classnames({ active: sortType === sort })}
          >
            <h4>{t(sortType)}</h4>
            {showDescription && (
              <div className={descriptorClass}>
                {t(`${sortType}_descriptor`)}
              </div>
            )}
          </Link>
        </li>
      ))}
    </ul>
  );
};
